import { render, staticRenderFns } from "./TranscriptRecordList.vue?vue&type=template&id=3d4e7aac&scoped=true&"
import script from "./TranscriptRecordList.vue?vue&type=script&lang=js&"
export * from "./TranscriptRecordList.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptRecordList.vue?vue&type=style&index=0&id=3d4e7aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e7aac",
  null
  
)

export default component.exports